'use client';

import { c as _c } from "react/compiler-runtime";
import type { ConnectedWalletOperation } from '@morfi/onramp-sdk';
import { type ReactNode, useEffect, useRef, useState } from 'react';
import { logger } from '@/lib/telemetry/logger';
import { connectedWalletMessage, connectedWalletMessageBinding } from './connected-wallet-widget-message';
const providerSandbox: string = ['allow-scripts', 'allow-same-origin', 'allow-forms', 'allow-popups', 'allow-popups-to-escape-sandbox', 'allow-top-navigation-by-user-activation'].join(' ');
export function FundingConnectedWalletFrame(t0) {
  const $ = _c(12);
  const {
    widget,
    onReady,
    onSuccess,
    onError
  } = t0;
  const frame = useRef(null);
  const [height, setHeight] = useState(600);
  let t1;
  let t2;
  if ($[0] !== onError || $[1] !== onReady || $[2] !== onSuccess || $[3] !== widget.allowedOrigin) {
    t1 = () => {
      const listener = event => {
        const activeFrame = frame.current?.contentWindow;
        const binding = connectedWalletMessageBinding(event.origin, event.source, activeFrame, widget.allowedOrigin);
        if (binding === "ignore") {
          return;
        }
        if (binding === "reject") {
          logger.warn("onramp.connected_wallet_message_rejected", {
            stage: "message_binding"
          });
          return;
        }
        const message = connectedWalletMessage(event.data);
        if (!message) {
          return;
        }
        if (message.kind === "ready") {
          onReady();
        } else {
          if (message.kind === "height") {
            setHeight(message.height);
          } else {
            if (message.kind === "success") {
              onSuccess();
            } else {
              onError();
            }
          }
        }
      };
      window.addEventListener("message", listener);
      return () => window.removeEventListener("message", listener);
    };
    t2 = [widget.allowedOrigin, onReady, onSuccess, onError];
    $[0] = onError;
    $[1] = onReady;
    $[2] = onSuccess;
    $[3] = widget.allowedOrigin;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  if (new URL(widget.url).origin !== widget.allowedOrigin) {
    throw new Error("connected_wallet_invalid_widget_origin");
  }
  let t3;
  if ($[6] !== onError) {
    t3 = () => {
      logger.warn("onramp.connected_wallet_frame_failed", {
        stage: "load"
      });
      onError();
    };
    $[6] = onError;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== height || $[9] !== t3 || $[10] !== widget.url) {
    t4 = <iframe ref={frame} title="MoonPay Connect Wallet" src={widget.url} allow="camera; clipboard-write; payment" sandbox={providerSandbox} height={height} className="w-full border-0" onError={t3} />;
    $[8] = height;
    $[9] = t3;
    $[10] = widget.url;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}